module.exports = __webpack_public_path__ + "fonts/icomoon.1f1fd56.eot";